import { FeedbackFormAlert, Section, Tray } from '@/components';
import APP_CONFIG from '@/config/app';
import { FC } from 'react';
interface FeedbackTrayProps {
  isOpen: boolean;
  onClose: () => void;
}
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const spacingConfig = {
  gap: `gap${APP_CONFIG.STYLES.MAIN_GAP}`,
};
const roundednessConfig = {
  roundedness: `rounded${APP_CONFIG.STYLES.MAIN_ROUNDEDNESS}`,
};
const colorConfig = {
  backgroundColor: 'bg-primary/10',
  borderColor: 'border border-primary/10',
};
const FeedbackTray: FC<FeedbackTrayProps> = ({ isOpen, onClose }) => {
  return (
    <Tray
      isOpen={isOpen}
      onClose={onClose}
      showHeaderCloseButton={true}
      screens={[
        {
          title: `Feedback`,
          content: (
            <Section
              body={<FeedbackFormAlert />}
              isFullBleed
              isBackgroundTransparent
              className={`${colorConfig.backgroundColor} 
                ${roundednessConfig.roundedness} 
                ${borderClassToVisualizeElementsAndSpacing}`}
            />
          ),
        },
      ]}
    />
  );
};
export default FeedbackTray;
